import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Avatar, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, Switch, Divider } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import { BASE_URL, ROLE_LEVEL_MAP, USER_LEVEL_MAP } from "src/config/constants";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import { alert } from "src/services/alert";
import plusFill from "@iconify/icons-eva/plus-fill";
import editFill from "@iconify/icons-eva/edit-fill";
import iconMenu2Fill from "@iconify/icons-eva/menu-2-fill";
import ListToolbar from "src/components/common/ListToolbar";
import ListHead from "src/components/common/ListHead";
import NavBack from "src/components/common/NavBack";
import { asyncRequest } from "src/services/network";
import UserInfo from "src/components/common/UserInfo";

const TABLE_HEAD = [
  { id: "nickname", label: "粉丝", alignRight: false },
  // { id: 'realname', label: '真实姓名', alignRight: false },
  { id: 'mobile', label: '手机号', alignRight: false },
  { id: "xfq", label: "消费券", alignRight: false },
  { id: "dhq", label: "兑换券", alignRight: false },
  { id: "pointsGreen", label: "绿色积分", alignRight: false },
  // { id: "point", label: "可提现余额", alignRight: false },
  // { id: "pointLocked", label: "福利余额", alignRight: false },
  { id: "childCount", label: "下级", alignRight: false },
  { id: "level", label: "商城等级", alignRight: false },
  { id: "roleLevel", label: "渠道等级", alignRight: false },
  // { id: "commission", label: "状态", alignRight: false },
  { id: "createdAt", label: "注册时间", alignRight: false },
  { id: "" },
];

const moreMenus = [
  { title: "详情", icon: editFill },
  // { title: "充值", icon: iconMenu2Fill },
  // { title: "加入黑名单", icon: iconMenu2Fill },
];

export default function UserParentDetail() {
  const navigate = useNavigate();
  const { uid } = useParams();

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [agent, setAgent] = useState({});
  const [parent, setParent] = useState({});
  const [agents, setAgents] = useState([]);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getTeam();
  }, [uid]);

  async function getTeam() {
    const { data } = await asyncRequest({
      path: "/user/detail",
      data: { uid },
    });

    setAgent(data.user);
    setParent(data.parent);
    setItems(data.childList);
  }

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "详情") {
      navigate(`/user/edit/${row.uid}`, { state: row });
    } else if (type === "加入黑名单") {
      // navigate(`/agent/blasklist/${row.id}`);
      blasklist(row.uid);
    }
  };

  async function blasklist(uid) {
    const { data } = await asyncRequest({
      path: "/agent/blasklist",
      data: { uid, to: true },
    });
  }

  return (
    <Page title="分销员管理">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title="分销员详情" />
        </Stack>

        <Card>
          <Stack direction="row" sx={{ height: 140 }}>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} sx={{ flex: 1 }}>
              <Avatar variant="square" alt={agent.nickname} src={agent.avatar} sx={{ width: 70, height: 70, borderRadius: 1 }} />
              <Stack>
                <Typography variant="subtitle2" noWrap>
                  昵称：{agent.nickname}
                </Typography>
                <Typography variant="subtitle2" noWrap>
                  姓名：{agent.realname}
                </Typography>
                <Typography variant="subtitle2" noWrap>
                  手机号：{agent.mobile}
                </Typography>
              </Stack>
            </Stack>

            <Divider orientation="vertical" />

            <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} sx={{ flex: 1 }}>
              {parent ? (
                <>
                  <Avatar alt={parent.nickname} src={parent.avatar} />
                  <Stack>
                    <Typography variant="subtitle2" noWrap>
                      上级分销商：{parent.nickname}
                    </Typography>
                    <Typography variant="subtitle2" noWrap>
                      姓名：{parent.realname}
                    </Typography>
                    <Typography variant="subtitle2" noWrap>
                      手机号：{parent.mobile}
                    </Typography>
                  </Stack>
                </>
              ) : (
                <Typography variant="subtitle2" noWrap>
                  无上级
                </Typography>
              )}
            </Stack>
          </Stack>
        </Card>

        <Card sx={{ mt: 2 }}>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { uid, mobile, nickname, realname, xfq, dhq, level, roleLevel, pointsGreen, createdAt, childCount, status } = row;

                    return (
                      <TableRow hover key={uid} tabIndex={-1} role="checkbox">
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}

                        <TableCell component="th" scope="row">
                          <UserInfo {...row} />
                        </TableCell>

                        <TableCell align="left">{mobile}</TableCell>
                        <TableCell align="left">{xfq}</TableCell>
                        <TableCell align="left">{dhq}</TableCell>
                        <TableCell align="left">{pointsGreen}</TableCell>

                        <TableCell align="left">
                          <RouterLink to={childCount ? `/user/parent/detail/${uid}` : ""}>{childCount}</RouterLink>
                        </TableCell>

                        <TableCell align="left">{USER_LEVEL_MAP[level]}</TableCell>
                        <TableCell align="left">{ROLE_LEVEL_MAP[roleLevel]}</TableCell>
{/* 
                        <TableCell align="left">
                          <Switch checked={status == 1} />
                        </TableCell> */}

                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {items.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>
    </Page>
  );
}
